<ng-container *ngIf="config?.itemPricingTableConfig as itemPricingTableConfig">
  <inventory-ui-item-pricing-table
    #itemPricingTable
    [config]="itemPricingTableConfig"
    [items]="items()"
    (updatedItemRow)="onUpdatedItemRow($event)"
  />
  <div class="selector-button-container">
    <button type="button" color="primary" mat-stroked-button class="selector-button" (click)="onAddItems()">
      + {{ 'COMMON.ACTIONS.ADD_ITEMS' | translate }}
    </button>
  </div>
</ng-container>
